import { isEmptyText, Prismic, PrismicText } from '@landsbankinn/prismic';
import { Column, Segment } from '@landsbankinn/ui';
import React from 'react';
import { Card } from '../components/card/Card';
import { Points } from '../components/slices/Points';

interface IProps {
  title: Prismic.RichText;
  text: Prismic.RichText;
  featured_point_title: Prismic.RichText;
  featured_point_text: Prismic.RichText;
  fields: IField[];
  template: string;
  isgray?: boolean;
}

interface IField {
  title: Prismic.RichText;
  text: Prismic.RichText;
}

export const PointsContainer = ({
  title,
  text,
  featured_point_title,
  featured_point_text,
  fields,
  template,
  isgray,
}: IProps) => {
  const isArticle = template === 'article';

  const renderFeaturedItem = () => {
    if (isEmptyText(featured_point_title)) {
      return null;
    }
    return (
      <Card
        title={Prismic.text(featured_point_title)}
        description={
          <PrismicText value={featured_point_text} isArticle={isArticle} />
        }
        notLink
        padding={false}
        backgroundAlt
      />
    );
  };

  return (
    <Segment isArticle={isArticle}>
      <Points
        title={Prismic.text(title)}
        copy={<PrismicText value={text} isArticle={isArticle} />}
        featured={renderFeaturedItem()}
        isGray={isgray}
      >
        {fields.length &&
          fields.map(({ title, text }, i) => (
            <React.Fragment key={`point-${i}`}>
              <Column md={{ width: 4 / 12 }}>
                <Card
                  title={Prismic.text(title)}
                  description={
                    <PrismicText value={text} isArticle={isArticle} />
                  }
                  notLink
                  padding={false}
                  backgroundAlt
                />
              </Column>
              {fields.length < 5 && i % 2 === 1 && fields.length !== 3 ? (
                <Column md={{ width: 4 / 12 }} />
              ) : null}
            </React.Fragment>
          ))}
      </Points>
    </Segment>
  );
};
